import svg4everybody from 'svg4everybody';

/**
 * SVG4everybody
 */
svg4everybody();
